module.exports = __webpack_public_path__ + "static/media/side bar phoneix logo.9ddce25f.svg";